/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyFileKey,
  ShopifyFileOriginalSourceKey,
  ShopifyFileSourcesKey,
  ShopifyFileToProductKey,
  ShopifyFileToProductVariantKey,
  ShopifyFileToShopKey,
  ShopifyProductKey,
  ShopifyProductMediaKey,
  ShopifyProductMediaToFileKey,
  ShopifyProductMediaToProductKey,
  ShopifyProductToFileKey,
  ShopifyProductVariantKey,
  ShopifyProductVariantMediaKey,
  ShopifyProductVariantMediaToFileKey,
  ShopifyProductVariantMediaToProductVariantKey,
  ShopifyProductVariantToFileKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyFileKey,
  defaultFilterableApiIdentifiers: ["mediaContentType"],
  "2022-01": {
    name: "Shopify File",
    graphQLTypename: "File",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "id", graphQLFragments: ["GenericFile", "MediaImage"] } },
      },
      {
        name: "Alt",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "alt" },
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "createdAt" } },
      },
      {
        name: "Type",
        fieldType: FieldType.Enum,
        configuration: {
          allowMultiple: false,
          allowOther: true,
          options: [{ name: "GenericFile" }, { name: "MediaImage" }, { name: "Video" }],
        },
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "__typename" } },
      },
      {
        name: "File Errors",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "fileErrors",
            graphQLFragments: ["GenericFile", "MediaImage"],
            graphQLSelection: `code
          details
          message`,
          },
        },
      },
      {
        name: "File Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "fileStatus", isShopifyEnum: true },
        },
        configuration: {
          allowMultiple: false,
          allowOther: true,
          options: [{ name: "FAILED" }, { name: "PROCESSING" }, { name: "READY" }, { name: "UPLOADED" }],
        },
      },
      {
        name: "Preview",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "preview",
            graphQLFragments: ["GenericFile", "MediaImage"],
            graphQLSelection: `image {
            id
            width
            height
            url
          }
          status`,
          },
        },
      },
      {
        name: "Image",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "image",
            graphQLFragments: ["MediaImage"],
            graphQLSelection: `id
          originalSrc: url
          width
          height`,
          },
        },
      },
      {
        key: ShopifyFileOriginalSourceKey,
        name: "Original Source",
        fieldType: FieldType.JSON,
      },
      {
        key: ShopifyFileSourcesKey,
        name: "Sources",
        fieldType: FieldType.JSON,
      },
      {
        name: "URL",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "url", graphQLFragments: ["GenericFile"] },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFileToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "files",
      filters: {},
    },
  },
  "2022-04": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "id", graphQLFragments: ["GenericFile", "MediaImage", "Video"] },
        },
      },
      {
        name: "Duration",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "duration", graphQLFragments: ["Video"] },
        },
      },
      {
        name: "Original File Size",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "originalFileSize", graphQLFragments: ["GenericFile"] },
        },
      },
      {
        name: "Preview",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "preview",
            graphQLFragments: ["GenericFile", "MediaImage", "Video"],
            graphQLSelection: `image {
              id
              width
              height
              url
            }
            status
          `,
          },
        },
      },
      {
        name: "Original Source",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "originalSource",
            graphQLFragments: ["Video"],
            graphQLSelection: `url
          width
          height
          format
          mimeType`,
          },
        },
      },
      {
        name: "Sources",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "sources",
            graphQLFragments: ["Video"],
            graphQLSelection: `url
          width
          height
          format
          mimeType`,
          },
        },
      },
      {
        name: "File Errors",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "fileErrors",
            graphQLFragments: ["GenericFile", "MediaImage", "Video"],
            graphQLSelection: `code
          details
          message`,
          },
        },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "files",
      filters: {},
    },
  },
  "2023-04": {
    syncConfig: {
      type: "graphql_list",
      resource: "files",
      filters: {
        updatedAt: { sortKey: "UPDATED_AT" },
        createdAt: { sortKey: "CREATED_AT" },
      },
      sortableBy: {
        updatedAt: { sortKey: "UPDATED_AT", reverse: true },
        createdAt: { sortKey: "CREATED_AT", reverse: true },
        filename: { sortKey: "FILENAME", reverse: false },
        id: { sortKey: "ID", reverse: false },
        originalUploadSize: { sortKey: "ORIGINAL_UPLOAD_SIZE", reverse: true },
        relevance: { sortKey: "RELEVANCE", reverse: false },
      },
    },
  },
  "2023-10": {
    fields: [
      {
        name: "Mimetype",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "mimeType",
            graphQLFragments: ["MediaImage"],
          },
        },
      },
    ],
  },
  "2024-07": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "id",
            shopifyFieldKey: "id",
            graphQLFragments: ["GenericFile", "MediaImage", "Video", "ExternalVideo", "Model3d"],
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "updatedAt",
            shopifyFieldKey: "updated_at",
            graphQLFragments: ["GenericFile", "MediaImage", "Video", "ExternalVideo", "Model3d"],
          },
        },
      },
      {
        name: "Embed Url",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "embedUrl", graphQLFragments: ["ExternalVideo"] },
        },
      },
      {
        name: "Host",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "host", graphQLFragments: ["ExternalVideo"] },
        },
        configuration: {
          allowOther: true,
          options: [{ name: "VIMEO" }, { name: "YOUTUBE" }],
        },
      },
      {
        name: "Media Content Type",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "mediaContentType",
            shopifyFieldKey: "media_content_type",
            graphQLFragments: ["ExternalVideo", "MediaImage", "Video", "Model3d"],
          },
        },
        configuration: {
          allowOther: true,
          options: [{ name: "EXTERNAL_VIDEO" }, { name: "IMAGE" }, { name: "MODEL_3D" }, { name: "VIDEO" }],
        },
      },
      {
        name: "Media Errors",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "mediaErrors",
            graphQLSelection: `
            code
            details
            message`,
            graphQLFragments: ["ExternalVideo", "MediaImage", "Video"],
          },
        },
      },
      {
        name: "Media Warnings",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "mediaWarnings",
            graphQLSelection: `
          code
          message`,
            graphQLFragments: ["ExternalVideo", "MediaImage", "Video", "Model3d"],
          },
        },
      },
      {
        name: "Origin Url",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "originUrl", graphQLFragments: ["ExternalVideo"] },
        },
      },
      {
        name: "Preview",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "preview_image",
            graphQLFieldKey: "preview",
            graphQLFragments: ["GenericFile", "MediaImage", "Video", "ExternalVideo", "Model3d"],
            graphQLSelection: `image {
              id
              width
              height
              url
            }
            status
          `,
          },
        },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "status",
            graphQLFieldKey: "status",
            graphQLFragments: ["ExternalVideo", "MediaImage", "Video", "Model3d"],
          },
        },
        configuration: {
          allowOther: true,
          options: [{ name: "FAILED" }, { name: "PROCESSING" }, { name: "READY" }, { name: "UPLOADED" }],
        },
      },
      {
        name: "File Errors",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "fileErrors",
            graphQLFragments: ["GenericFile", "MediaImage", "Video", "ExternalVideo", "Model3d"],
            graphQLSelection: `code
          details
          message`,
            requiredScopes: ["read_files"],
          },
        },
      },
      {
        name: "Bounding Box",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "boundingBox",
            graphQLFragments: ["Model3d"],
            graphQLSelection: `size {
              x
              y
              z
            }
          `,
          },
        },
      },
      {
        name: "Filename",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "filename",
            graphQLFragments: ["Model3d", "Video"],
          },
        },
      },
      {
        name: "Original Source",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "originalSource",
            graphQLFragments: [
              {
                type: "Video",
                selection: `
                originalSource {
                  fileSize
                  format
                  mimeType
                  url
                  height
                  width
                }
                `,
              },
              {
                type: "Model3d",
                selection: `
                originalSource {
                  filesize
                  format
                  mimeType
                  url
                }
                `,
              },
            ],
          },
        },
      },
      {
        name: "Sources",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "sources",
            graphQLFragments: [
              {
                type: "Video",
                selection: `sources {
                  fileSize
                  format
                  height
                  mimeType
                  url
                  width
                }
                `,
              },
              {
                type: "Model3d",
                selection: `sources {
                  filesize
                  format
                  mimeType
                  url
                  }
                `,
              },
            ],
          },
        },
      },
      {
        name: "Product",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyFileToProductKey,
        configuration: {
          joinModelKey: ShopifyProductMediaKey,
          relatedModelKey: ShopifyProductKey,
          inverseJoinModelFieldKey: ShopifyProductMediaToFileKey,
          inverseRelatedModelFieldKey: ShopifyProductMediaToProductKey,
          inverseFieldKey: ShopifyProductToFileKey,
        },
      },
      {
        name: "Product Variant",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyFileToProductVariantKey,
        configuration: {
          joinModelKey: ShopifyProductVariantMediaKey,
          relatedModelKey: ShopifyProductVariantKey,
          inverseJoinModelFieldKey: ShopifyProductVariantMediaToFileKey,
          inverseRelatedModelFieldKey: ShopifyProductVariantMediaToProductVariantKey,
          inverseFieldKey: ShopifyProductVariantToFileKey,
        },
      },
      {
        name: "File Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "fileStatus",
            graphQLFragments: ["GenericFile", "MediaImage", "Video", "ExternalVideo", "Model3d"],
            isShopifyEnum: true,
          },
        },
        configuration: {
          allowMultiple: false,
          allowOther: true,
          options: [{ name: "FAILED" }, { name: "PROCESSING" }, { name: "READY" }, { name: "UPLOADED" }],
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "createdAt",
            shopifyFieldKey: "created_at",
            graphQLFragments: ["GenericFile", "MediaImage", "Video", "ExternalVideo", "Model3d"],
          },
        },
      },
      {
        name: "Alt",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "alt", shopifyFieldKey: "alt" },
        },
      },
    ],
  },
};

export const ShopifyFile = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
